export default __webpack_public_path__ + "static/media/alignment-h-left.bb60fd2b.svg";